// 瓜田日报 静态演示数据 —— 仅用于展示，接入后端后替换

export const COLUMNS = [
  { key: "all", name: "全部瓜田" },
  { key: "明星动态", name: "明星动态" },
  { key: "影视综艺", name: "影视综艺" },
  { key: "网络热梗", name: "网络热梗" },
  { key: "热搜解读", name: "热搜解读" },
];

export interface Article {
  id: number;
  category: string;
  title: string;
  summary: string;
  cover: string;
  author: string;
  date: string;
  read: number;
  likes: number;
  tags: string[];
  featured?: boolean;
  body: string[];
}

export const ARTICLES: Article[] = [
  {
    id: 101,
    category: "热搜解读",
    title: "吃瓜的正确姿势：信息差时代，先核实再讨论",
    summary: "热点来得快去得也快，与其被情绪裹挟，不如先问一句：这件事的事实边界在哪里？本文聊聊健康吃瓜的几个实用原则。",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20entertainment%20news%20still%20life%20on%20warm%20cream%20paper%2C%20stack%20of%20printed%20tabloid%20newspapers%2C%20magnifying%20glass%20and%20reading%20glasses%2C%20terracotta%20and%20marigold%20tone%2C%20soft%20natural%20light%2C%20minimal%20magazine%20art%20direction&width=1200&height=800&seq=melon-art-101&orientation=landscape",
    author: "瓜田编辑部",
    date: "09-07 08:20",
    read: 38210,
    likes: 3264,
    tags: ["热点观点", "理性吃瓜", "信息素养"],
    featured: true,
    body: [
      "在热点层出不穷的当下，「先发制人」的转发往往比「求实」更容易获得认同。但每次冲动转发，都在为不实信息添一把火。真正成熟的吃瓜，是把「我看到」和「我知道」区分开。",
      "建议把信息分成三档：官方/一手信源、可信媒体、以及来路不明的截图与爆料。讨论前，优先引用前两档；对第三档，保留「存疑」态度，而不是当作结论扩散。",
      "吃瓜本身没有错，它是社交的一部分，也是公共讨论的入口。关键是别让情绪替代事实核查，别让立场决定我们对同一件事的双重标准。",
      "最后一条：如果一条消息让你感到异常「解气」或异常「愤怒」，先停下来数三秒。情绪最激烈的时候，往往是判断最脆弱的时候。慢一点，才能看清全貌。",
    ],
  },
  {
    id: 102,
    category: "明星动态",
    title: "新剧杀青路透刷屏，主创深夜发文感谢观众",
    summary: "一部都市剧刚完成拍摄，从开机到杀青一路被网友「云监工」。杀青夜，几位主演与导演轮流发文，字里行间都是真感情。",
    cover: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20tv%20drama%20set%2C%20clapperboard%20and%20cinema%20camera%20on%20warm%20cream%20background%2C%20terracotta%20lighting%2C%20editorial%20still%20life%2C%20film%20production%20mood%2C%20clean%20composition&width=1200&height=800&seq=melon-art-102&orientation=landscape",
    author: "瓜田前线",
    date: "09-06 22:15",
    read: 45120,
    likes: 5218,
    tags: ["影视资讯", "剧组动态"],
    body: [
      "从三月初开机到现在，这部剧共拍摄了整整五个月。期间主创每隔一段就会放出幕后花絮，让追剧网友参与感拉满，被戏称为「全平台最透明的剧组」。",
      "杀青当晚，导演在长文中回顾了几个「差点放弃又坚持下来」的拍摄瞬间，坦言最珍贵的不是收视，而是剧组把每个小角色都当回事的较真劲。",
      "几位主演随后接力发文，有人晒出杀青合影，有人写下一段写给角色的告别。粉丝在评论区感叹：这种「售后」比剧情本身还上头。",
      "业内人士分析，真诚的创作过程最能积累路人好感。当剧组把幕后诚实地摊开给观众看，信任感自然就建立起来了，也为正式开播攒足了期待。",
    ],
  },
  {
    id: 103,
    category: "影视综艺",
    title: "年度黑马综艺口碑爆棚：慢下来，才能看见真实",
    summary: "没有剧本冲突、没有强人设，这档「慢综艺」反而成了今年评分最高的一档节目。它凭什么打动越来越挑剔的观众？",
    cover: "https://readdy.ai/api/search-image?query=cozy%20warm%20variety%20show%20living%20room%20set%20with%20sofa%20and%20plants%2C%20afternoon%20sunlight%20through%20window%2C%20cream%20and%20terracotta%20tone%2C%20relaxed%20documentary%20mood%2C%20editorial%20photography&width=1200&height=800&seq=melon-art-103&orientation=landscape",
    author: "瓜田编辑",
    date: "09-06 18:40",
    read: 33450,
    likes: 4092,
    tags: ["综艺推荐", "口碑榜"],
    body: [
      "在这个节奏快到连吃饭都要倍速的时代，一档「什么也不争」的节目反而杀出重围。嘉宾们每天做饭、散步、聊天，没有任务卡，也没有刻意制造的冲突。",
      "观众们说，最打动人的恰恰是那些「失控」的瞬间：聊到一半沉默、突然岔开的话题、没有排演的小情绪。真实，成了当下最稀缺的综艺资源。",
      "制作团队复盘时提到，他们做的最大减法，是删掉了所有可能引发对立剪辑的素材。取舍本身，就是对观众的一种尊重。",
      "口碑发酵带动了二刷和长尾讨论，不少网友把它当成「下饭陪伴」循环播放。这或许提醒行业：观众要的不是更多刺激，而是能安放情绪的真诚内容。",
    ],
  },
  {
    id: 104,
    category: "网络热梗",
    title: "从「请出山」到「退退退」，这个夏天的梗文化又卷起来了",
    summary: "一个夏天过去，社交平台上的流行语换了一茬又一茬。我们追踪了这些热梗的来龙去脉，也聊聊梗文化为何总在更新换代。",
    cover: "https://readdy.ai/api/search-image?query=colorful%20sticker%20and%20emoji%20collage%20flat%20lay%20on%20warm%20cream%20desk%2C%20speech%20bubbles%20and%20playful%20typography%2C%20marigold%20and%20terracotta%20accents%2C%20modern%20internet%20culture%20mood%2C%20clean%20composition&width=1200&height=800&seq=melon-art-104&orientation=landscape",
    author: "热梗观察员",
    date: "09-05 20:10",
    read: 28940,
    likes: 3678,
    tags: ["网络文化", "流行语"],
    body: [
      "流行语的寿命越来越短，这既是语言演化的常态，也是注意力碎片化的写照。一条梗能火多久，往往取决于它能不能承载共享的情绪。",
      "很多出圈梗都有一个共同点：足够「普适」。无论是自嘲、反击还是解压，它让不同身份的人都能在同一句里找到自己。梗，本质是情绪的通用货币。",
      "创作者追逐新梗、品牌方借梗营销，也让梗的迭代不断加速。上一轮还没被玩透，下一轮已经上路，这是生态的一部分。",
      "对普通网友来说，不必焦虑跟不上节奏。热梗可以当社交润滑剂，但真正耐人寻味的，永远是梗背后那些真实的生活切片。",
    ],
  },
  {
    id: 105,
    category: "热搜解读",
    title: "刷屏的「名场面」如何诞生？聊聊二创与版权边界",
    summary: "一条高能片段全网刷屏，往往离不开网友的二创加持。但当剪辑、配音、改写遇上版权，兴奋与风险总是相伴而行。",
    cover: "https://readdy.ai/api/search-image?query=creative%20video%20editing%20workspace%20top%20view%2C%20laptop%20timeline%20and%20scissors%20cutting%20film%20strip%2C%20warm%20cream%20table%2C%20terracotta%20tone%2C%20editorial%20flat%20lay%20photography&width=1200&height=800&seq=melon-art-105&orientation=landscape",
    author: "瓜田编辑部",
    date: "09-05 15:02",
    read: 21560,
    likes: 2380,
    tags: ["二创", "版权", "内容生态"],
    body: [
      "「名场面」通常不是凭空出现的，很多高光片段在正片里只是短短几秒，是二创的二次加工让它们拥有了传播的生命力。",
      "合理的二次创作，能为原作品带来讨论度与长尾流量，许多片方也乐见其成。可一旦越过「引用与点评」的合理限度，变成对原作品的完整搬运或商用，风险就会随之而来。",
      "普通观众能做的是：为喜欢的二创点个赞，也尊重原作者标注的转载要求；而创作者则需要在表达自由与版权之间找到那条清晰的线。",
      "健康的生态，既需要创作者被看见，也需要原创被尊重。二者并行，才能让好内容源源不断。",
    ],
  },
  {
    id: 106,
    category: "明星动态",
    title: "演唱会门票开售即罄，粉丝经济学到底在买什么",
    summary: "一场巡演开票瞬间售罄，黄牛与抢票大战再次成为话题。粉丝们为之买单的，仅仅是一场演出吗？",
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20lights%20and%20silhouetted%20crowd%20with%20raised%20phones%2C%20warm%20golden%20glow%20and%20terracotta%20tone%2C%20electric%20live%20music%20energy%2C%20editorial%20music%20photography&width=1200&height=800&seq=melon-art-106&orientation=landscape",
    author: "瓜田前线",
    date: "09-04 21:30",
    read: 39880,
    likes: 4310,
    tags: ["演唱会", "粉丝文化"],
    body: [
      "开售三分钟内，绝大多数场次便显示「缺货登记」。粉丝们一边吐槽抢票难度，一边研究最优的网络与设备策略，俨然一场小型的「技术博弈」。",
      "对很多乐迷而言，现场的意义远超听几首歌。它是一次集体的情绪共振、一段可以反复回味的记忆，也是对一个阶段的自我确认。",
      "随之而来的黄牛话题依旧无解：当稀缺被推向市场，逐利者便闻风而动。平台反复强调「强实名」，粉丝则呼吁更公平的放票机制。",
      "说到底，门票背后的「粉丝经济学」，买的是陪伴感与归属感。只要这份真诚还在，哪怕过程波折，热爱的奔赴也依然值得。",
    ],
  },
  {
    id: 107,
    category: "影视综艺",
    title: "悬疑剧爆款方法论：好的剧本不怕被剧透",
    summary: "不少悬疑剧一旦被剧透就「废了」，可真正的顶配作品，哪怕知道结局，重看依旧上头。差别到底在哪？",
    cover: "https://readdy.ai/api/search-image?query=mystery%20novel%20and%20old%20film%20noir%20props%2C%20typewriter%20and%20foggy%20lantern%2C%20warm%20shadow%20lighting%2C%20terracotta%20and%20deep%20brown%20palette%2C%20suspense%20mood%2C%20editorial%20still%20life&width=1200&height=800&seq=melon-art-107&orientation=landscape",
    author: "剧评观察",
    date: "09-04 17:45",
    read: 25600,
    likes: 3120,
    tags: ["剧评", "悬疑"],
    body: [
      "行业里常说「剧透是悬疑剧的天敌」。但回顾那些封神的作品，它们的精彩从不只依赖一个反转的惊喜，而在于过程本身的扎实。",
      "反转若是唯一的底牌，真相揭晓后作品便失去了再次被观看的价值；而真正的高级写法，是把伏笔织进每一场戏，让观众回头看时处处有回响。",
      "这也是为什么有些剧即使被完整剧透，人们依然愿意一遍遍重刷——因为看的不再是「结果」，而是角色如何一步步走向结果，以及藏在细节里的另一层故事。",
      "对创作者而言，最踏实的爆款方法论，或许就是把「意外」建立在「必然」之上：让悬念服务于人物，而非凌驾于人物。",
    ],
  },
  {
    id: 108,
    category: "网络热梗",
    title: "表情包考古学：从早期网络到今日的「社交货币」",
    summary: "从黑白像素到高清动图，表情包陪我们走过了二十多年。它早已不只是聊天工具，而是一套属于当代人的交流语言。",
    cover: "https://readdy.ai/api/search-image?query=retro%20computer%20keyboard%20and%20meme%20sticker%20collection%20on%20warm%20cream%20desk%2C%20colorful%20pixel%20art%20accents%2C%20marigold%20and%20terracotta%20tone%2C%20playful%20editorial%20still%20life&width=1200&height=800&seq=melon-art-108&orientation=landscape",
    author: "热梗观察员",
    date: "09-03 19:20",
    read: 17890,
    likes: 2265,
    tags: ["表情包", "网络文化"],
    body: [
      "在还没有高清屏的年代，一个简单的符号表情就能化解尴尬。后来表情包逐渐取代文字成为「语境补充」，同一句话配不同表情，含义可以天差地别。",
      "如今表情包成了一种高效的社交工具：它降低表达门槛，缓和语气，也帮助性格内敛的人更自在地开启话题。懂得接梗、会抛图，被视为一种「聊天情商」。",
      "但从另一个角度看，过度依赖表情包，也可能让真实情感变得模糊。当所有人都习惯用梗来回应时，深层的沟通反而需要更多勇气去直说。",
      "表情包的进化史，其实是一面镜子，照出我们表达方式的变迁。学会用梗，也别忘了保留一句不借梗的真心话。",
    ],
  },
  {
    id: 109,
    category: "热搜解读",
    title: "热搜上的电影宣发大战：谁在制造话题，谁在消耗耐心",
    summary: "一部新片上映前后，热搜上总能看到密集的话题。热闹背后，是精心策划的营销，还是观众的自来水？",
    cover: "https://readdy.ai/api/search-image?query=movie%20poster%20billboards%20and%20search%20hashtag%20mockup%20collage%2C%20warm%20cream%20studio%2C%20terracotta%20and%20marigold%20accents%2C%20modern%20marketing%20campaign%20mood%2C%20editorial%20design&width=1200&height=800&seq=melon-art-109&orientation=landscape",
    author: "瓜田编辑部",
    date: "09-03 12:08",
    read: 30240,
    likes: 2940,
    tags: ["电影宣发", "行业观察"],
    body: [
      "电影营销早已不是简单的预告片投放。从主创访谈、点映口碑到话题造势，一部影片的热搜排布，背后常有一整套精密的时间表。",
      "适度的宣发能帮好作品被更多人看见，这是良性的。但当营销动作过于喧哗、甚至用争议和「对打」来换取注意力时，观众会本能地产生疲惫与警惕。",
      "真正的口碑还是得靠内容本身兑现。观众可以为一次精彩的映后互动买单，也会为一支过满的宣传曲而皱眉——衡量尺度，始终是真诚与否。",
      "对观众来说，与其被话题牵着走，不如把选择权交还给自己：走进影院前的每一次决定，都值得先看一眼真实评价，而不是热搜排名。",
    ],
  },
  {
    id: 110,
    category: "明星动态",
    title: "综艺里的老朋友回来了，回忆杀背后是长青的共鸣",
    summary: "当熟悉的阵容在多年后重新合体，弹幕里飘满「爷青回」。怀旧为何总能精准击中我们？",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20polaroid%20photos%20and%20vintage%20cassette%20tape%20on%20cream%20background%2C%20warm%20sunlight%2C%20terracotta%20tone%2C%20sentimental%20editorial%20still%20life%2C%20soft%20composition&width=1200&height=800&seq=melon-art-110&orientation=landscape",
    author: "瓜田前线",
    date: "09-02 20:05",
    read: 24800,
    likes: 3510,
    tags: ["综艺", "回忆杀"],
    body: [
      "当节目组放出多年前的花絮，当熟悉的嘉宾再一次同框，弹幕瞬间被「爷青回」刷屏。这种情绪，几乎是全民共通的。",
      "怀旧之所以强大，是因为它让我们短暂地「回到过去」——回到那段无论好坏都被记忆柔光处理的时光。它带来的不止是感动，更是一种身份确认：原来我们都好好地长大了。",
      "对节目而言，情怀是一张好牌，却不是唯一。观众既期待旧友重逢，也期待新的火花。若只消费过往而缺少新的内容增量，再浓的回忆杀也会快速退烧。",
      "好在老朋友们没有让人失望：他们既聊旧事，也分享当下的变化与成长。回忆是桥，而真正留住观众的，是桥那头仍在继续的真诚关系。",
    ],
  },
  {
    id: 111,
    category: "影视综艺",
    title: "小众纪录片逆袭：把镜头对准普通人，反而最出圈",
    summary: "没有流量明星、没有华丽布景，一档聚焦普通人的纪录片却在各平台刷屏。平凡故事的感染力，远超想象。",
    cover: "https://readdy.ai/api/search-image?query=documentary%20film%20crew%20recording%20everyday%20street%20life%2C%20handheld%20camera%20silhouette%2C%20warm%20golden%20hour%2C%20cream%20and%20terracotta%20palette%2C%20candid%20cinematic%20mood&width=1200&height=800&seq=melon-art-111&orientation=landscape",
    author: "剧评观察",
    date: "09-02 11:40",
    read: 16800,
    likes: 2090,
    tags: ["纪录片", "口碑片"],
    body: [
      "片名平平无奇，阵容里没有一个熟悉的面孔，可它播出的第二天，相关话题便悄悄爬上热搜。主角是菜市场摊主、夜班司机、返乡青年……他们是你我身边的普通人。",
      "主创团队表示，他们刻意放弃了「猎奇」视角，选择长时间跟拍，只呈现人物最真实的生活流。没有解说词去下结论，把判断留给观众。",
      "这种克制反而成就了巨大的共情。观众在别人的日常里看到了自己的影子：那些咬牙坚持的时刻、微小而确定的幸福，比任何宏大叙事都更打动人。",
      "它的出圈，印证了一个朴素道理：真实自有万钧之力。当内容不再端着，而是愿意平视每一个认真生活的人，观众自然会给予回应。",
    ],
  },
  {
    id: 112,
    category: "网络热梗",
    title: "为什么我们都爱「造梗」？语言游戏背后的情绪出口",
    summary: "把一句普通的话变成全网通用语，需要几步？造梗、传梗的背后，藏着当代人怎样的表达心理？",
    cover: "https://readdy.ai/api/search-image?query=typewriter%20with%20colorful%20words%20floating%20like%20confetti%2C%20playful%20typography%20art%2C%20warm%20cream%20and%20terracotta%20background%2C%20creative%20writing%20mood%2C%20editorial%20illustration%20style&width=1200&height=800&seq=melon-art-112&orientation=landscape",
    author: "热梗观察员",
    date: "09-01 16:22",
    read: 14900,
    likes: 1870,
    tags: ["造梗", "语言现象"],
    body: [
      "一条梗能火，往往始于一句足够精准的话：它用最少的字，戳中了最多人共同经历的某个瞬间。当大家发现「这句话太好用了」，传播便一触即发。",
      "造梗也是一种低成本的情绪表达。比起长篇大论，一个自嘲的梗就能化解尴尬、缓冲压力，把复杂的心情压缩成一句会心一笑。",
      "从众与创造力在这里奇妙地共存：我们一边模仿热梗寻求认同，一边在玩梗中加入自己的巧思，让梗在流传中不断「长出新皮肤」。",
      "语言本来就是活着的。热梗像是当代汉语的年轻血液，记录着这一代人的喜怒哀乐。若干年后回看，它们会是最鲜活的时代注脚。",
    ],
  },
];

export const HOT_LIST = [
  { rank: 1, title: "新剧杀青路透刷屏，主创深夜发文感谢观众", heat: "482万", id: 102, tag: "明星" },
  { rank: 2, title: "年度黑马综艺口碑爆棚：慢下来，才能看见真实", heat: "461万", id: 103, tag: "综艺" },
  { rank: 3, title: "吃瓜的正确姿势：先核实再讨论", heat: "427万", id: 101, tag: "观点" },
  { rank: 4, title: "演唱会门票开售即罄，粉丝经济学到底在买什么", heat: "403万", id: 106, tag: "明星" },
  { rank: 5, title: "热搜上的电影宣发大战：谁在制造话题", heat: "376万", id: 109, tag: "行业" },
  { rank: 6, title: "从「请出山」到「退退退」，热梗又卷起来了", heat: "352万", id: 104, tag: "热梗" },
  { rank: 7, title: "综艺里的老朋友回来了，回忆杀背后的共鸣", heat: "318万", id: 110, tag: "综艺" },
  { rank: 8, title: "小众纪录片逆袭：把镜头对准普通人", heat: "289万", id: 111, tag: "口碑" },
];

export const HERO_STORY = {
  id: 101,
  kicker: "今日瓜田 · 深度长文",
  title: "吃瓜的正确姿势：信息差时代，先核实再讨论",
  summary: "热点来得快去得也快，与其被情绪裹挟，不如先问一句：这件事的事实边界在哪里？一份写给所有爱看热闹的人的「理性吃瓜指南」。",
  date: "2026.09.07",
  read: 38210,
  cover: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20magazine%20cover%20scene%2C%20warm%20cream%20backdrop%20with%20terracotta%20spotlights%20and%20marigold%20glow%2C%20stacked%20newspapers%20and%20a%20golden%20magnifying%20glass%2C%20soft%20shadows%2C%20refined%20journalism%20mood%2C%20high%20detail&width=1600&height=900&seq=melon-hero-main&orientation=landscape",
};

export const SECONDARY_STORIES = [
  {
    id: 102,
    category: "明星动态",
    title: "新剧杀青路透刷屏，主创深夜发文感谢观众",
    summary: "从开机到杀青一路被网友「云监工」，杀青夜的接力发文，字里行间都是真感情。",
    date: "09-06",
    cover: "https://readdy.ai/api/search-image?query=warm%20drama%20set%20clapperboard%20behind%20the%20scenes%20still%20life%2C%20cream%20and%20terracotta%20tone%2C%20soft%20lighting%2C%20editorial%20film%20mood&width=900&height=640&seq=melon-sec-102&orientation=landscape",
  },
  {
    id: 103,
    category: "影视综艺",
    title: "年度黑马综艺口碑爆棚：慢下来，才能看见真实",
    summary: "没有剧本冲突，这档慢综艺凭什么打动越来越挑剔的观众？",
    date: "09-06",
    cover: "https://readdy.ai/api/search-image?query=cozy%20sofa%20sunlit%20variety%20set%20with%20plants%2C%20warm%20cream%20and%20terracotta%2C%20relaxed%20editorial%20documentary%20mood&width=900&height=640&seq=melon-sec-103&orientation=landscape",
  },
];

export const GALLERY = [
  { title: "名场面图鉴 · 那些反复被提起的片段", cover: "https://readdy.ai/api/search-image?query=montage%20of%20dramatic%20film%20frames%20collage%2C%20warm%20terracotta%20and%20cream%20tone%2C%20editorial%20poster%20style%2C%20cinematic%20mood&width=800&height=800&seq=melon-gal-1&orientation=squarish" },
  { title: "夏日街头 · 松弛感穿搭盘点", cover: "https://readdy.ai/api/search-image?query=candid%20street%20fashion%20moment%2C%20warm%20summer%20light%20and%20cream%20backdrop%2C%20terracotta%20tones%2C%20editorial%20fashion%20photography&width=800&height=800&seq=melon-gal-2&orientation=squarish" },
  { title: "综艺花絮 · 那些没播的幕后瞬间", cover: "https://readdy.ai/api/search-image?query=laughter%20behind%20the%20scenes%20on%20set%2C%20camera%20and%20lighting%20gear%2C%20warm%20cream%20and%20terracotta%2C%20candid%20editorial%20photo&width=800&height=800&seq=melon-gal-3&orientation=squarish" },
  { title: "追剧日历 · 本月值得蹲的作品", cover: "https://readdy.ai/api/search-image?query=cinema%20calendar%20with%20tickets%20and%20popcorn%20on%20warm%20desk%2C%20marigold%20and%20terracotta%20tone%2C%20cozy%20editorial%20flat%20lay&width=800&height=800&seq=melon-gal-4&orientation=squarish" },
  { title: "舞台现场 · 灯光下的高光时刻", cover: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20golden%20beams%20and%20silhouette%2C%20terracotta%20ambience%2C%20editorial%20live%20music%20mood&width=800&height=800&seq=melon-gal-5&orientation=squarish" },
  { title: "文字人间 · 一句戳中你的台词", cover: "https://readdy.ai/api/search-image?query=handwritten%20quotes%20on%20warm%20cream%20paper%20with%20coffee%2C%20terracotta%20ink%2C%20serene%20editorial%20typography%20still%20life&width=800&height=800&seq=melon-gal-6&orientation=squarish" },
];

export const FAQ = [
  {
    q: "瓜田日报每天更新什么内容？",
    a: "我们每日聚合明星动态、影视综艺、网络热梗与热搜解读四类吃瓜资讯，以图文报道和精选图集为主，节假日也有追剧日历与年度盘点等内容。",
  },
  {
    q: "这里的资讯可靠吗？",
    a: "我们坚持「先核实再发布」的内容原则，优先引用可查证的一手信源与权威媒体报道，对来路不明的传闻会明确标注「存疑」，不以博眼球为目的。",
  },
  {
    q: "可以把喜欢的文章保存或转发吗？",
    a: "欢迎在遵守转载规范的前提下分享。若需转载图文到其他平台，请保留来源链接并注明出处，涉及二创请参考原文的版权说明。",
  },
  {
    q: "想投稿或提供素材，如何联系编辑部？",
    a: "欢迎通过首页底部与「联系我们」页的投稿表单提交。请附上事件的可信来源，我们会在核实后与选题一同评估，符合规范的内容会优先发布。",
  },
];

export const COMMENTS = [
  { name: "苏打气泡", role: "资深吃瓜网友", text: "在这个快节奏时代，还有平台愿意认真做「核实再聊」的内容，真的很难得。吃瓜也吃出方法论了。" },
  { name: "一只追剧猫", role: "影综爱好者", text: "每天中午必刷的新鲜瓜田，图集和追剧日历太对我胃口，更新很稳，观点也正向。" },
  { name: "北纬三十度", role: "平台读者", text: "最打动我的是不贩卖焦虑、不煽动对立。理性吃瓜这四个字，他们是真的在践行。" },
];

export const FOOTER_LINKS = [
  { name: "关于我们", to: "/about" },
  { name: "明星动态", to: "/rexun?cat=明星动态" },
  { name: "影视综艺", to: "/rexun?cat=影视综艺" },
  { name: "网络热梗", to: "/rexun?cat=网络热梗" },
  { name: "热搜解读", to: "/rexun?cat=热搜解读" },
];